import _ from "lodash";
import React from "react";
import * as Yup from "yup";
import { Col, Typography, Row } from "antd";
import { inject, observer } from "mobx-react";
import { Link, useHistory, useLocation } from "react-router-dom";
import AppButton from "components/AppButton/AppButton";
import SignupLogo from "assets/images/login-signup/Guni.png";
import Footer from "components/Authentication/Common/Footer";
import styles from "components/Authentication/Common/auth.module.css";
import SplitView from "../Common/SplitView"; // Import the SplitView component
import useWindowWidth from "hooks/useWindowWidth"; // Hook to get window width

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Enter valid Email!")
    .required("Email is Required!")
});

function View(props) {
  const { children, authStore, withFooter = true, title, subtitle, heroImage, features = [], leftContent, showSplit = false, logoImages } = props;
  const history = useHistory();
  const location = useLocation();
  const { width } = useWindowWidth(); // Get the current window width

  return (
    <>
      <Row type="flex" align="center" justify="start">
        <Col span={24}>
          {showSplit ? (
            <SplitView
              title={title}
              subtitle={subtitle}
              heroImage={heroImage}
              features={features}
              leftContent={leftContent}
              logoImages={logoImages}
              rightContent={
                <Row>
                  <Col span={24} className="flex-grow-1 p-0 p-md-2">
                    {children}
                  </Col>
                  {withFooter && location.pathname === "/signup" && (
                    <Col span={24} className="mt-2 text-start">
                      <Footer />
                    </Col>
                  )}
                </Row>
              }
            />
          ) : (
            <Col span={24} className={`${styles.loginCol}`}>
              <Row className={`${styles.loginContainer}`}>
                <Col span={24} className="flex-grow-1 p-0 p-md-2">
                  {children}
                </Col>
                {withFooter && (
                  <Col span={24} className="mt-2">
                    <Footer />
                  </Col>
                )}
              </Row>
            </Col>
          )}
        </Col>
      </Row>
    </>
  );
}

export default inject(stores => ({
  authStore: stores.store.authStore
}))(observer(View));
